import { spotInfoLinkLocation } from "../util/util";
import React from "react";
import { SpotMarker } from "../datastructures";
import { Icon } from "leaflet";
import { Marker, Tooltip } from "react-leaflet";
import { useNavigate } from "react-router";

interface SpotActivityMarkerProperties {
  key: string;
  marker: SpotMarker;
}

export const SpotActivityMarker: React.FC<SpotActivityMarkerProperties> = ({
  marker,
}) => {
  const linkTarget = spotInfoLinkLocation(
    marker.spot_id,
    marker.iconnr,
    marker.etime,
  );

  function createIcon(iconnr: number): Icon {
    return new Icon({
      iconUrl: process.env.PUBLIC_URL + "/images/icons/t_" + iconnr + ".svg",
      iconSize: [35, 35], //[26, 26], // size of the icon
      iconAnchor: [17, 17], // point of the icon which will correspond to marker's location
      popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
    });
  }

  const navigate = useNavigate();

  return (
    <Marker
      key={"spot_" + marker.spot_id + "_" + marker.etime + "_" + marker.iconnr}
      position={[marker.n, marker.e]}
      icon={createIcon(marker.iconnr)}
      eventHandlers={{ click: () => navigate(linkTarget) }}
    >
      <Tooltip>{marker.spot_name}</Tooltip>
    </Marker>
  );
};
